import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class DeveloperActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/Developer/DeveloperBrowser")
	}

	render() {
		return (
			<Activity 
				name="Developer"
				RenderedComponent={this.RenderedComponent}
				context="Developer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(DeveloperActivity)
